module.exports = __webpack_public_path__ + "media/images/new/icons/gradient_arrow-997f14a6b8da9303d6b63108e8026780.png";